import { Navigate } from 'react-router-dom'

/**
 * Protects admin routes.
 * Reads the admin session token from sessionStorage.
 * If not present, redirects to /admin/login.
 */
export default function AdminRoute({ children }) {
  const token = sessionStorage.getItem('adminToken')
  if (!token) {
    return <Navigate to="/admin/login" replace />
  }
  return children
}
